// Позиция «Новое» — появилась на складе (пришла новой в выгрузке 1С) или снова появилась
// в наличии не больше 7 дней назад.
export const NEW_ITEM_DAYS = 7;

// API отдаёт UTC без зоны («2026-10-28T09:30:00») — без «Z» браузер прочёл бы как местное время.
function parseUtc(value) {
  if (!value) return NaN;
  const raw = String(value);
  return Date.parse(/[zZ]|[+-]\d\d:?\d\d$/.test(raw) ? raw : `${raw}Z`);
}

export function isNewItem(item, now = Date.now()) {
  if (!item) return false;
  const times = [parseUtc(item.created_at), parseUtc(item.restocked_at)].filter((t) => !Number.isNaN(t));
  if (!times.length) return false;
  return now - Math.max(...times) < NEW_ITEM_DAYS * 24 * 60 * 60 * 1000;
}
